var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.961H0V-0.00585938Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 110.91V231.145H513V110.91H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 110.91H513V150.988H0V110.91Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 191.067H513V231.145H0V191.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.383 -0.00585938H316.617V341.961H196.383V-0.00585938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.383 -0.00585938H236.461V341.961H196.383V-0.00585938Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.237 -0.00585938H315.315V341.961H275.237V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 294.368C324.619 294.368 379.84 239.147 379.84 171.028C379.84 102.909 324.619 47.6871 256.5 47.6871C188.381 47.6871 133.16 102.909 133.16 171.028C133.16 239.147 188.381 294.368 256.5 294.368Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 58.7086L261.109 72.9364H276.138L264.015 81.8537L268.624 96.0815L256.5 87.2643L244.376 96.0815L248.985 81.8537L236.862 72.9364H251.891L256.5 58.7086ZM190.471 80.1504L202.695 88.9676L214.819 80.1504L210.21 94.4783L222.333 103.296H207.304L202.695 117.523L197.986 103.296H182.957L195.08 94.4783L190.471 80.1504ZM149.692 136.26H164.721L169.33 122.032L174.039 136.26H189.069L176.845 145.077L181.554 159.405L169.33 150.588L157.206 159.405L161.815 145.077L149.692 136.26ZM149.692 205.695L161.815 196.878L157.206 182.55L169.33 191.367L181.554 182.55L176.845 196.878L189.069 205.695H174.039L169.33 220.023L164.721 205.695H149.692ZM190.471 261.905L195.08 247.577L182.957 238.76H197.986L202.695 224.432L207.304 238.76H222.333L210.21 247.577L214.819 261.905L202.695 252.987L190.471 261.905ZM256.5 283.346L251.891 269.019H236.862L248.985 260.201L244.376 245.873L256.5 254.691L268.624 245.873L264.015 260.201L276.138 269.019H261.109L256.5 283.346ZM322.529 261.905L310.305 252.987L298.181 261.905L302.79 247.577L290.667 238.76H305.696L310.305 224.432L315.014 238.76H330.043L317.92 247.577L322.529 261.905ZM363.308 205.695H348.279L343.67 220.023L338.961 205.695H323.931L336.155 196.878L331.446 182.55L343.67 191.367L355.794 182.55L351.185 196.878L363.308 205.695ZM363.308 136.26L351.185 145.077L355.794 159.405L343.67 150.588L331.446 159.405L336.155 145.077L323.931 136.26H338.961L343.67 122.032L348.279 136.26H363.308ZM322.529 80.1504L317.92 94.4783L330.043 103.296H315.014L310.305 117.523L305.696 103.296H290.667L302.79 94.4783L298.181 80.1504L310.305 88.9676L322.529 80.1504Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.846 169.024C268.824 147.882 265.317 143.875 265.317 143.875C265.317 143.875 265.718 134.156 265.718 128.244C265.718 119.427 258.304 112.413 249.186 112.413C240.569 112.413 233.455 115.319 232.654 123.435C228.445 124.337 224.037 127.543 224.037 134.156C224.037 138.965 225.039 141.47 229.247 143.474C231.351 138.865 233.555 138.664 238.565 137.061C239.367 137.662 240.268 140.067 241.17 140.468L241.471 141.47C241.471 141.47 228.145 148.083 228.145 172.43C228.145 201.988 250.188 217.919 250.188 217.919L248.384 218.22L246.48 225.333H268.523V218.119L279.545 235.654C279.846 235.353 289.765 187.961 279.846 169.024Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/DM.88287e16903a61ecb67fcfbaa294a013.svg";
export { ForwardRef as ReactComponent };